import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { replace } from 'react-router-redux';
import {
  Card,
  Dimmer,
  Grid,
  Label,
  Loader,
  Segment,
  Table,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import PageNav from './PageNav';
import SearchFilter from './SearchFilter';
import LoadImage from './LoadImage';
import PictureItem from './PictureItem';
import { flashErrorMessage } from '../actions/flash';
import { fetchM } from '../actions/fetchM';
import isNumber from '../utils/numbers/isNumber';
import { decodeSearch, encodeSearch } from '../utils/url';
import { namespaces } from '../constants/translation';

class LogoList extends Component {
  static propTypes = {
    notFoundNode: PropTypes.func,
    onClick: PropTypes.func,
    onCheck: PropTypes.func,
    onViewLarge: PropTypes.func,
    onRemove: PropTypes.func,
    onChange: PropTypes.func,
    headerNode: PropTypes.func,
    footerNode: PropTypes.func,
    buttonNode: PropTypes.func,
    where: PropTypes.shape({}),
    toggleable: PropTypes.bool,
    view: PropTypes.oneOf(['list', 'card']),
    searchRightNav: PropTypes.node,
    loading: PropTypes.bool,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    let advanceFilter = false;
    const isMobile = window.innerWidth < 768;
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const types = query.types || [];
    if (
        (types && types.length > 0)
      ) {
      advanceFilter = true;
    }
    return {
      advanceFilter,
      isMobile,
      currentPage,
      search,
      types,
    };
  }
  constructor(props) {
    super(props);
    const state = LogoList.getPropsToState(props);
    const view = props.view || 'list';
    this.state = {
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      view,
      ...state,
    };
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    this.replaceQuery(query);
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = LogoList.getPropsToState(nextProps);
    if (nextProps.view) {
      if (this.state.view !== nextProps.view) {
        state.view = nextProps.view;
      }
    }
    this.setState(state);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setLogos(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
        if (this.props.onChange) {
          this.props.onChange(this.state.data);
        }
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchLogos(q = {}) {
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign(q, this.props.where || {});
    const url = `/logos/?${qs.stringify(query)}`;
    let res;
    try {
      res = await store.dispatch(fetchM(url, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const data = await res.json();
      await this.setLogos(data);
      if (this.state.data.length < 1 && query.page > 1) {
        const que = decodeSearch(this.props.location.search);
        que.page = 1;
        this.replaceQuery(que);
      } else {
        // handle token.. etc
        await this.setComponentState({
          count,
          limit,
          offset,
        });
      }
    }
    await this.setLoading(false);
  }
  handleResize = () => {
    const isMobile = window.innerWidth < 768;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    this.fetchLogos(queryNew);
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  handleRefetch() {
    const query = decodeSearch(this.props.location.search);
    this.replaceQuery(query);
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  handleOnClick = (e, logo) => {
    if (this.props.onClick) {
      this.props.onClick(e, logo);
    }
  }
  handleToggleView = (e) => {
    e.preventDefault();
    const view = this.state.view === 'list' ? 'card' : 'list';
    this.setState({ view });
  }
  handleOnCheck = (logo) => {
    if (this.props.onCheck) {
      return this.props.onCheck({ logo });
    }
    return false;
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    this.setState({
      search: '',
    }, () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  handleSetAdvanceFilter = (advanceFilter) => {
    this.setState({
      advanceFilter,
    });
  }
  handleViewLarge = (e, logo) => {
    if (this.props.onViewLarge) {
      this.props.onViewLarge(e, logo);
    }
  }
  handleOnRemove = (e, logo) => {
    if (this.props.onRemove) {
      this.props.onRemove(e, logo);
    }
  }
  renderLabel = (logo) => {
    const { t } = this.props;
    if (logo.label && logo.label.trim().length > 0) {
      return logo.label;
    }
    if (this.state.isMobile) {
      return <span className="grey-text">{t('No label set')}</span>;
    }
    return '-';
  }
  renderBody() {
    const { t } = this.props;
    if (this.state.view === 'list') {
      return (
        this.state.data.length > 0 ?
        this.state.data.map((logo, key) => (
          <Table.Row
            key={key}
            disabled={this.handleOnCheck(logo)}
            onClick={e => this.handleOnClick(e, logo)}
          >
            {
              !this.state.isMobile &&
              <Table.Cell width={5}>
                <LoadImage
                  constrain
                  as="a"
                  centered
                  size="tiny"
                  picture={logo}
                  pictureSize={50}
                  extension="png"
                  onClick={e => this.handleViewLarge(e, logo)}
                />
              </Table.Cell>
            }
            {
              !this.state.isMobile &&
              <Table.Cell width={5}>
                {this.renderLabel(logo)}
              </Table.Cell>
            }
            {
              this.state.isMobile ? (
                <Table.Cell width={16}>
                  <Grid columns="equal">
                    <Grid.Column width={6}>
                      <LoadImage
                        constrain
                        as="a"
                        centered
                        size="tiny"
                        picture={logo}
                        pictureSize={50}
                        extension="png"
                        onClick={e => this.handleViewLarge(e, logo)}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Grid columns="equal">
                        <Grid.Row>
                          <Grid.Column width={16}>
                            {this.renderLabel(logo)}
                          </Grid.Column>
                        </Grid.Row>
                        {
                          this.props.buttonNode ? (
                            <Grid.Row>
                              <Grid.Column width={16} textAlign="right">
                                {
                                  this.props.buttonNode({
                                    loading: this.state.loading,
                                    logo,
                                    view: this.state.view,
                                    isMobile: this.state.isMobile,
                                  })
                                }
                              </Grid.Column>
                            </Grid.Row>
                          ) : null
                        }
                      </Grid>
                    </Grid.Column>
                  </Grid>
                </Table.Cell>
              ) : null
            }
            {
              !this.state.isMobile &&
              <Table.Cell>
                {
                  this.props.buttonNode ? (
                    <div className="picture-list-buttons">
                      {
                        this.props.buttonNode({
                          loading: this.state.loading,
                          logo,
                          view: this.state.view,
                          isMobile: this.state.isMobile,
                        })
                      }
                    </div>
                  ) : null
                }
              </Table.Cell>
            }
          </Table.Row>
        )) : (
          <Table.Row>
            <Table.Cell colSpan={this.state.isMobile ? null : 3} textAlign="center">
              {
                this.state.loading ? <Loader active inline="centered">{t('Loading')}</Loader>
                : (this.props.notFoundNode || <p>{t('No logos found')}.</p>)
              }
            </Table.Cell>
          </Table.Row>
        )
      );
    }
    return (
      <Table.Row>
        <Table.Cell>
          <Card.Group itemsPerRow={this.state.data.length > 0 ? 4 : 1} doubling stackable>
            {
              this.state.data.length > 0 ?
              this.state.data.map((logo, key) => (
                <PictureItem
                  key={key}
                  picture={logo}
                  pictureSize={50}
                  onViewLarge={e => this.handleViewLarge(e, logo)}
                  onRemove={e => this.handleOnRemove(e, logo)}
                  extension="png"
                  hideTags
                  fixedSize
                  buttonNode={this.props.buttonNode ?
                    this.props.buttonNode({
                      loading: this.state.loading,
                      logo,
                      view: this.state.view,
                    }) : null
                  }
                />
              )) : (
                <Card>
                  <Segment textAlign="center" vertical>
                    {
                      this.state.loading ? <Loader active inline="centered">{t('Loading')}</Loader>
                      : (this.props.notFoundNode || <p>{t('No logos found')}.</p>)
                    }
                  </Segment>
                </Card>
              )
            }
          </Card.Group>
        </Table.Cell>
      </Table.Row>
    );
  }
  render() {
    const {
      count, limit, offset, data, loading, currentPage, view,
    } = this.state;
    const { t } = this.props;
    return (
      <div>
        <Dimmer
          inverted style={{ zIndex: 20 }}
          active={(this.state.loading || this.props.loading) && this.state.data.length > 0}
        >
          <Loader inline="centered">{t('Loading')}</Loader>
        </Dimmer>
        <Table
          fixed={view === 'card'}
          striped unstackable
        >
          <Table.Header fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan={this.state.isMobile ? null : 3}>
                <Grid columns={1} verticalAlign="middle">
                  {
                    this.props.toggleable &&
                    <Grid.Column>
                      <Label
                        as="button"
                        attached="top left"
                        size="small"
                        icon={`${view === 'list' ? 'block' : 'list'} layout`}
                        content={t(view === 'list' ? 'Card' : 'List')}
                        onClick={this.handleToggleView}
                        disabled={this.state.loading}
                      />
                    </Grid.Column>
                  }
                  <Grid.Column>
                    {
                      this.props.headerNode ?
                      this.props.headerNode({
                        count,
                        limit,
                        offset,
                        dataSize: data.length,
                        loading,
                        currentPage,
                        onChange: this.handleChangePage,
                      }) : (
                        <SearchFilter
                          inTable
                          advanceFilter={this.state.advanceFilter}
                          isLoading={loading}
                          onChange={this.handleFilterOnChange}
                          onClose={this.handleClearFilter}
                          search={this.state.search}
                          setAdvanceFilter={this.handleSetAdvanceFilter}
                          leftNav={(
                            <PageNav
                              currentPage={currentPage}
                              count={count}
                              limit={limit}
                              offset={offset}
                              dataSize={data.length}
                              loading={loading}
                              onChange={this.handleChangePage}
                            />
                          )}
                          rightNav={this.props.searchRightNav}
                        />
                      )
                    }
                  </Grid.Column>
                </Grid>
              </Table.HeaderCell>
            </Table.Row>
            {
              view === 'list' &&
              !this.state.isMobile &&
              <Table.Row>
                <Table.HeaderCell>{t('Logo')}</Table.HeaderCell>
                <Table.HeaderCell>{t('Label')}</Table.HeaderCell>
                <Table.HeaderCell />
              </Table.Row>
            }
          </Table.Header>
          <Table.Body>
            {this.renderBody()}
          </Table.Body>
          <Table.Footer fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan={this.state.isMobile ? null : 3}>
                {
                  this.props.footerNode ?
                  this.props.footerNode({
                    count,
                    limit,
                    offset,
                    dataSize: data.length,
                    loading,
                    currentPage,
                    onChange: this.handleChangePage,
                  }) : (
                    <Grid columns="equal" verticalAlign="middle">
                      <Grid.Column>
                        <PageNav
                          upward
                          currentPage={currentPage}
                          count={count}
                          limit={limit}
                          offset={offset}
                          dataSize={data.length}
                          loading={loading}
                          onChange={this.handleChangePage}
                        />
                      </Grid.Column>
                    </Grid>
                  )
                }
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(withRouter(LogoList, { withRef: true }));



// WEBPACK FOOTER //
// ./src/components/LogoList.jsx